import Swiper from "swiper";
import { Navigation } from 'swiper/modules';
import "swiper/css";

// timeline
$("body").on("timelineDataReady", function () {
    const swipers = document.querySelectorAll(
        ".timeline-container .swiper"
    );

    const updateControlLabels = function (swiper, index) {
        let $prevBtn = $(swiper.navigation.prevEl);
        let $nextBtn = $(swiper.navigation.nextEl);
        // update controls
        let $prevNavBtn = $(
            `.timeline-navigation button[data-index="${index - 1}"]`
        );
        let $nextNavBtn = $(
            `.timeline-navigation button[data-index="${index + 1}"]`
        );

        $prevBtn.find(".label").text($prevNavBtn.find(".label").text());
        $nextBtn.find(".label").text($nextNavBtn.find(".label").text());
    };
    const navItemWidth = 100; // this needs to match the width set in the block styles

    const updateNavigationPosition = function (swiper, index) {
        $(".timeline-navigation").scrollLeft(index * navItemWidth);
        $(`.timeline-navigation button`).removeClass("active");
        $(`.timeline-navigation button[data-index="${index}"]`).addClass(
            "active"
        );
    };

    const updateTimelineContent = function (index) {
        $(`.timeline-content .item`).removeClass("active");
        $(`.timeline-content .item[data-index="${index}"]`).addClass("active");
    };

    swipers.forEach((el, index) => {
        el.classList.add(`slider-timeline-${index}`);

        const swiper = new Swiper(`.slider-timeline-${index}`, {
            modules: [Navigation],
            slidesPerView: 1,
            slidesPerGroup: 1,
            speed: 600,
            centeredSlides: true,
            navigation: {
                prevEl: `.timeline-container .slider-control.prev`,
                nextEl: `.timeline-container .slider-control.next`,
            },
            on: {
                init: function () {
                    updateControlLabels(this, 0);
                },
                slideChange: function () {
                    updateControlLabels(this, this.activeIndex);
                    updateNavigationPosition(this, this.activeIndex);
                    updateTimelineContent(this.activeIndex);
                },
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    spaceBetween: 30,
                },
            },
        });

        $(".timeline-navigation button").on("click", function (e) {
            e.preventDefault();
            let index = $(this).data("index");
            swiper.slideTo(index);
            $(".timeline-navigation button").removeClass("active");
            $(this).addClass("active");

            updateControlLabels(swiper, index);
            updateTimelineContent(index);
        });
    });
});

$(document).ready(function () {
    $('body').trigger('timelineDataReady');
});
